import split from './split';

export default function updateBase(name: string, fn: (base: string) => string): string {
  const parsed = split(name);

  return parsed ? `${fn(parsed[0])}.${parsed[1]}` : fn(name);
}
